import { render, staticRenderFns } from "./DownloadXMPButton.vue?vue&type=template&id=6645c5f2&scoped=true&"
import script from "./DownloadXMPButton.vue?vue&type=script&lang=js&"
export * from "./DownloadXMPButton.vue?vue&type=script&lang=js&"
import style0 from "./DownloadXMPButton.vue?vue&type=style&index=0&id=6645c5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6645c5f2",
  null
  
)

export default component.exports